import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'
import Shop from '@/views/Shop.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/donate',
    name: 'Donate',
    component: () => import('../views/Donate.vue')
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('../views/Events.vue')
  },
  {
    path: '/events/:id',
    name: 'EventDetails',
    component: () => import('../views/EventDetails.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/orders',
    name: 'AdminOrders',
    component: () => import('../views/AdminOrders.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/my-orders',
    name: 'UserOrders',
    component: () => import('../views/UserOrders.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin-setup',
    name: 'AdminSetup',
    component: () => import('../views/AdminSetup.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (user clicked back/forward), use it
    if (savedPosition) {
      return savedPosition;
    }
    
    // If the route has a hash, scroll to it
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    
    // Otherwise scroll to top
    return { top: 0 };
  }
})

// Navigation guard for protected routes
router.beforeEach(async (to, from, next) => {
  // Wait for auth to initialize before proceeding
  if (!store.state.auth.initialized) {
    console.log('Auth not initialized, initializing...');
    await store.dispatch('auth/init')
  }

  console.log('Auth initialized:', store.state.auth.initialized);
  console.log('Is authenticated:', store.getters['auth/isAuthenticated']);
  console.log('Is anonymous:', store.getters['auth/isAnonymous']);

  // Check for admin routes
  const isAdminRoute = to.path.startsWith('/admin');

  // Clear event data when navigating to event details to prevent caching
  if (to.name === 'EventDetails') {
    store.commit('events/CLEAR_CURRENT_EVENT');
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/isAuthenticated']) {
      console.log('Authentication required but user not authenticated, redirecting to login');
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else if (isAdminRoute && store.getters['auth/isAnonymous']) {
      console.log('Admin access attempted by anonymous user, redirecting to login');
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      console.log('User authenticated, proceeding to', to.path);
      next();
    }
  } else {
    next();
  }
})

export default router 